import { map } from 'es-toolkit/compat';
import { oc } from 'ts-optchain';
import clsx from 'clsx';

import { core } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';
import CreditCard from 'components/credit-cards/CreditCard';

interface Props {
  cards: core.PaymentCard[];
  disabled?: boolean;
  selectedCard?: core.PaymentCard;
  modifierClassName?: string;
  onSelect?(card: core.PaymentCard): void;
  onDelete(card: core.PaymentCard): void;
}

export default class CreditCards extends BaseComponent<Props> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static defaultProps: any;

  render() {
    const { cards } = this.props;
    const className = clsx('CreditCards', this.props.modifierClassName);

    return (
      <div className={className}>
        {map(cards, (card) => (
          <CreditCard
            key={card.storedToken}
            card={card}
            disabled={this.props.disabled}
            isSelected={card.storedToken === oc(this.props.selectedCard).storedToken()}
            onDelete={this.props.onDelete}
            onSelect={this.props.onSelect}
          />
        ))}
      </div>
    );
  }
}

CreditCards.defaultProps = {
  modifierClassName: '',
};
